import { isArray, isEqual, isObject, transform } from 'lodash-es';
import { Action, ActionReducer, MetaReducer } from '@ngrx/store';
import { State } from '~/modules';
import { DebugService } from '~/shared/services/debug.service';
import { environment } from '#environment';

// https://davidwells.io/snippets/get-difference-between-two-objects-javascript
const difference = (stateBefore: State, stateAfter: State): Partial<State> => {
  if (stateBefore === undefined || stateAfter === undefined) {
    return null;
  }
  const changes = (before: State, after: State): Partial<State> => {
    let arrayIndexCounter = 0;
    return transform(after, (result, value, key) => {
      if (!isEqual(value, before[key])) {
        const resultKey = isArray(before) ? arrayIndexCounter++ : key;
        result[resultKey] = isObject(value) && isObject(before[key]) ? changes(before[key], value) : value;
      }
    });
  };

  return changes(stateBefore, stateAfter);
};

const logActionAndStateChange = (stateBefore: State, stateAfter: State, action: Action, debugService: DebugService) => {
  if (environment.debug === true) {
    const args = [
      'action:',
      action,
      'state before action:',
      stateBefore,
      'state after action:',
      stateAfter,
      'state diff:',
      difference(stateBefore, stateAfter)
    ];
    // TODO 09-Jun-2023/braune: grepping for 'failure' is a bit of a heuristic approach
    if (action.type.toLowerCase().indexOf('failure') >= 0) {
      debugService.logError(action.type, ...args);
    } else {
      debugService.logMessage(action.type, ...args);
    }
  }
};

export const loggingMetaReducerFactory =
  (debugService: DebugService): MetaReducer<State> =>
  (reducer: ActionReducer<State>) =>
  (stateBefore, action) => {
    const stateAfter = reducer(stateBefore, action);
    logActionAndStateChange(stateBefore, stateAfter, action, debugService);
    return stateAfter;
  };
